import React from "react";
import DropDown from "../dropdown/DropDown";
import TripOptions from "../inputfields/TripOptions";
import "./DepotToDepot.css";

function DepotToDepot({
  depotList,
  toDepotList,
  selectedTo,
  setSelectedTo,
  selectedFrom,
  setSelectedFrom,
  estimatePrice,
  nextStep,
}) {
  const [fromIsActive, setFromIsActive] = React.useState(false);
  const [toIsActive, setToIsActive] = React.useState(false);
  React.useEffect(() => {
    if (fromIsActive && toIsActive) {
      setToIsActive(false);
    }
  }, [fromIsActive]);
  React.useEffect(() => {
    if (toIsActive && fromIsActive) {
      setFromIsActive(false);
    }
  }, [toIsActive]);

  return (
    <>
      <div className="tab-container">
        <div className="depotToDepot-container">
          <div className="toAndFrom">
            <div className="toAndFrom-dropDowns">
              <DropDown
                label="Where will you drop off your vehicle?"
                selected={selectedFrom}
                setSelected={setSelectedFrom}
                menuItems={depotList}
                isActive={toIsActive}
                setIsActive={setToIsActive}
              />
            </div>
            <div className="toAndFrom-dropDowns">
              <DropDown
                label="Where will you collect your vehicle?"
                selected={selectedTo}
                setSelected={setSelectedTo}
                menuItems={toDepotList}
                isActive={fromIsActive}
                setIsActive={setFromIsActive}
              />
            </div>
          </div>
        </div>

        <div className="estimatePrice">Estimate price: {estimatePrice}</div>

      </div>

      <div className="btn-container">
        <button className="btn-next" onClick={nextStep}>
          Continue
        </button>
      </div>

    </>
  );
}

export default DepotToDepot;
